import { Helpers } from '../../helpers';
import { IGenSubSub } from '../../interfaces/igen-sub-sub';
import { CompletionsRentalUnitCost } from '../completions-rental-unit-cost';
import { DrillingCost } from '../drilling-cost';

export class GenSubSubBase {
  Gen: string;
  Sub: string;
  SubSub: string;
  Description: string;
  GenSubSubId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CompletionsRentalUnitCosts_GenSubSub?: Array<CompletionsRentalUnitCost> | null;
  DrillingCosts_GenSubSub?: Array<DrillingCost> | null;

  constructor(item?: IGenSubSub) {
    if (item) {

      this.Gen = item.Gen;
      this.Sub = item.Sub;
      this.SubSub = item.SubSub;
      this.Description = item.Description;
      this.GenSubSubId = item.GenSubSubId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CompletionsRentalUnitCosts_GenSubSub = Helpers.createClassArray(CompletionsRentalUnitCost, item.CompletionsRentalUnitCosts_GenSubSub);
      this.DrillingCosts_GenSubSub = Helpers.createClassArray(DrillingCost, item.DrillingCosts_GenSubSub);
    }
  }
}